import { createContext, useContext } from 'react';

// Shared "subscription required" gate. App owns the state (access mode from
// the GoodGPT admin config plus the active subscription) and publishes it
// here, so any feature can block a usage action — sending text or voice —
// and raise the pricing prompt with a single check instead of every
// component fetching subscription state on its own.
const PaywallContext = createContext({
  required: false,   // subscription-only mode is on and there is no active plan
  prompt: () => {},  // opens the pricing prompt
});

export const PaywallProvider = PaywallContext.Provider;

export function usePaywall() {
  return useContext(PaywallContext);
}
